export default {
  pageTitle: {
    text: "Request Redetermination",
  },
  sections: [
    {
      fields: [
        {
          machine_name: "fileType",
          value: "Redetermination Request Document",
          widget: "text",
          style: {
            display: "none",
          },
        },
        {
          machine_name: "files",
          widget: "file_upload",
          file_upload: { fileType: "Redetermination Request Document" },
          accept_multiple: false,
          checkFilesAdded: true,
          documentAuth: "dh",
        },
        {
          machine_name: "document_description",
          widget: "text",
          label: "Document Description",
          validate: ["required"],
          maxLength: 100,
          isVisible: {
            when: "files",
            is: [undefined, null],
            operator: "filesExist",
            hideStyles: true,
          },
        },
        {
          machine_name: "case_note",
          widget: "text_area",
          validate: ["required"],
          label: "Note",
          inputLimit: 4000,
          rows: 7,
        },
      ],
    },
  ],
};
